/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Flickity from 'flickity';

/*------------------------------------*\
    NAVIGATION MODULE
\*------------------------------------*/
class FullWidthCarousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        var flkty = new Flickity( self.elem, {
          // options
          cellAlign: 'left',
          contain: false,
          selectedAttraction: 0.01,
          friction: 0.15,
          wrapAround: true,
          pageDots: true
        });


    }
}

export default FullWidthCarousel;
